import React, { useEffect, useState } from "react";
import DataOverview from "../components/data/DataOverview";
import { useLocation, useMatch, useParams } from "react-router-dom";
import Loader from "../components/layouts/Loader";

const title = "FAQs";
const tableName = "faqs";
const editPathName = "/faqs/:id";
const tableColumns = [
  {
    dataField: "question",
    text: "Question",
    displayName: "Question",
    sort: true,
  },
  {
    dataField: "tools",
    displayName: "Tools",
    text: "Tools",
    sort: false,
  },
];
const fieldData = [
  {
    fieldName: "question",
    displayName: "Question",
    placeholder: "Question",
    fieldType: "text",
    colSize: 1,
    required: true,
    requiredMessage: "Field is required!",
  },
  {
    fieldName: "answer",
    displayName: "Answer",
    placeholder: "Answer",
    fieldType: "content",
    colSize: 1,
    required: true,
    requiredMessage: "Field is required!",
  },
];
const fieldDataDefault = {
  question: "",
  answer: "",
};

const FAQs = () => {
  const { id } = useParams();
  const location = useLocation();
  const match = useMatch(editPathName);
  const [loading, setLoading] = useState(true);
  let parentRoute = location.pathname;
  useEffect(() => {
    setLoading(false);
  }, []);

  if (match) {
    parentRoute = match.pattern.path.replace("/:id", "");
  }

  if (loading) return <Loader />;
  return (
    <DataOverview
      id={id ?? ""}
      tableName={tableName}
      pageMode={id ? "edit" : "list"}
      route={location.pathname}
      parentRoute={parentRoute}
      pageTitle={title}
      listTitle={title}
      listSubTitle={""}
      addTitle={"Add "}
      addSubTitle={""}
      editTitle={`Edit ${title}`}
      editSubTitle={""}
      tableColumns={tableColumns}
      fieldData={fieldData}
      fieldDataDefault={fieldDataDefault}
    />
  );
};

export default FAQs;
